const DefaultLmc = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.03471 6.65498C6.03471 7.05735 6.05041 7.45183 6.07396 7.83843C6.64097 8.18167 7.13672 8.63173 7.53396 9.16389C10.0772 12.4618 11.0976 18.5999 11.0976 18.5999C11.0976 18.5999 14.724 11.8148 14.724 6.65498C14.724 -0.224822 6.03471 -0.477293 6.03471 6.65498Z"
      fill="#B8A6C9"
    />
    <path
      d="M6.07396 7.83851C2.79289 5.89765 -1.05334 9.54268 1.9844 13.4875C5.67364 18.2766 11.0976 18.6 11.0976 18.6C11.0976 18.6 6.56847 14.6236 6.07396 7.83851Z"
      fill="#B8A6C9"
    />
    <path
      d="M17.7932 14.4816C17.3399 14.9623 16.7932 15.3441 16.1869 15.6034C15.5805 15.8626 14.9277 15.9937 14.2688 15.9885C14.2277 15.3267 14.3229 14.6635 14.5485 14.0403C14.774 13.4172 15.125 12.8475 15.5796 12.3669C16.0341 11.8864 16.5825 11.5052 17.1902 11.2473C17.798 10.9894 18.4522 10.8603 19.1119 10.8681C19.1499 11.5291 19.0524 12.1908 18.8256 12.8124C18.5987 13.434 18.2473 14.0021 17.7932 14.4816Z"
      fill="#B8A6C9"
    />
  </svg>
)

export default DefaultLmc
